/*!
 * 1DS JS SDK Properties plugin, 2.4.7
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* PropertiesPlugin.ts
* @author Abhilash Panwar (abpanwar) Hector Hernandez (hectorh)
* @copyright Microsoft 2018
*/
import dynamicProto from '@microsoft/dynamicproto-js';
import { BaseTelemetryPlugin, setProcessTelemetryTimings, Utils, objForEachKey } from '@microsoft/1ds-core-js';
import { TelemetryContext } from './TelemetryContext';
import { Extensions } from './Extensions';
var PropertiesPlugin = /** @class */ (function (_super) {
    __extends(PropertiesPlugin, _super);
    function PropertiesPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = 'SystemPropertiesCollector';
        _this.priority = 3;
        _this.version = '2.4.7';
        var _context;
        var _properties = {};
        dynamicProto(PropertiesPlugin, _this, function (_self, _base) {
            _self.initialize = function (coreConfig, core, extensions) {
                _super.prototype.initialize.call(_this, coreConfig, core, extensions);
                _context = new TelemetryContext(coreConfig, _self._getTelCtx().getExtCfg(_self.identifier), core);
            };
            /**
             * Process the event and add part A fields to it.
             * @param event - The event that needs to be stored.
             * @param itemCtx - This is the context for the current request, ITelemetryPlugin instances
             * can optionally use this to access the current core instance or define / pass additional information
             * to later plugins (vs appending items to the telemetry item)
             */
            _self.processTelemetry = function (event, itemCtx) {
                setProcessTelemetryTimings(event, _self.identifier);
                itemCtx = _self._getTelCtx(itemCtx);
                var evtExt = event.ext = event.ext ? event.ext : {};
                event.data = event.data ? event.data : {};
                evtExt[Extensions.AppExt] = evtExt[Extensions.AppExt] || {};
                evtExt[Extensions.UserExt] = evtExt[Extensions.UserExt] || {};
                evtExt[Extensions.WebExt] = evtExt[Extensions.WebExt] || {};
                evtExt[Extensions.OSExt] = evtExt[Extensions.OSExt] || {};
                evtExt[Extensions.SdkExt] = evtExt[Extensions.SdkExt] || {};
                evtExt[Extensions.IntWebExt] = evtExt[Extensions.IntWebExt] || {};
                evtExt[Extensions.UtcExt] = evtExt[Extensions.UtcExt] || {};
                evtExt[Extensions.LocExt] = evtExt[Extensions.LocExt] || {};
                evtExt[Extensions.DeviceExt] = evtExt[Extensions.DeviceExt] || {};
                evtExt[Extensions.TraceExt] = evtExt[Extensions.TraceExt] || {};
                evtExt[Extensions.CloudExt] = evtExt[Extensions.CloudExt] || {};
                _context.applyApplicationContext(event);
                _context.applyUserContext(event);
                _context.applyWebContext(event);
                _context.applyOsContext(event);
                _context.applySdkContext(event);
                _context.applyIntWebContext(event);
                _context.applyUtcContext(event);
                _context.applyLocContext(event);
                _context.applySessionContext(event);
                _context.applyDeviceContext(event);
                _context.applyAITraceContext(event);
                _context.applyCloudContext(event);
                //Delete empty ext fields
                Utils.arrForEach(Utils.objKeys(evtExt), function (key) {
                    if (Utils.objKeys(evtExt[key]).length === 0) {
                        delete evtExt[key];
                    }
                });
                //Add custom properties
                _addPropertiesIfAbsent(_properties, event.data);
                _self.processNext(event, itemCtx);
            };
            /**
             * Get properties context to override or specify specific part A properties
             * @returns the Context
             */
            _self.getPropertiesContext = function () {
                return _context;
            };
            /**
             * Sets a custom property to be sent with every event. IEventProperty can be used to tag the property as
             * pii or customer content.
             * @param name - The name of the property.
             * @param value - The context property's value.
             */
            _self.setProperty = function (name, value) {
                _properties[name] = value;
            };
            function _addPropertiesIfAbsent(inputMap, outputMap) {
                if (inputMap) {
                    objForEachKey(inputMap, function (name, inputValue) {
                        if (!outputMap[name]) {
                            outputMap[name] = inputValue;
                        }
                    });
                }
            }
        });
        return _this;
    }
// Removed Stub for PropertiesPlugin.prototype.initialize.
// Removed Stub for PropertiesPlugin.prototype.processTelemetry.
// Removed Stub for PropertiesPlugin.prototype.getPropertiesContext.
// Removed Stub for PropertiesPlugin.prototype.setProperty.
    return PropertiesPlugin;
}(BaseTelemetryPlugin));
export default PropertiesPlugin;
//# sourceMappingURL=PropertiesPlugin.js.map